export default __webpack_public_path__ + "static/media/blue.1b7cce63.svg";